import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { UIStoreModule } from './module';

export const UIModule = getModule(UIStoreModule, store);
